


















import Vue from 'vue'
import { USER_TIME_ZONE } from '@/utils/time'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'
import { buildBodyWeightChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/body-weight/BodyWeightChartOption'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    startTimestamp(): number {
      return this.patientWithStats.resultStartTimestamp
    },
    endTimestamp(): number {
      return this.patientWithStats.resultEndTimestamp
    },
    timezone(): string {
      return this.patientWithStats.timezone || USER_TIME_ZONE
    },
    bodyWeightChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine> | any {
      if (!this.patientWithStats || !this.patientWithStats?.bodyWeightsLastOneDaily?.length) {
        return null
      }

      return buildBodyWeightChartOption({
        bodyWeights: this.patientWithStats?.bodyWeights,
        bodyWeightsRollingAvg: this.patientWithStats?.bodyWeightsRollingAvg ?? [],
        timezone: this.timezone,
        startTimestamp: this.patientWithStats?.resultStartTimestamp,
        endTimestamp: this.patientWithStats?.resultEndTimestamp,
        colors: this.$vuetify.theme.themes.light,
      })
    },
  },
})
